import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  const appKey = process.env.REACT_APP_API_KEY;
  if (appKey) {
    config.headers['x-app-key'] = appKey;
  }

  return config;
});

export default api;
